import { api } from "../../services/NetworkBase";

export async function GetTestProcesses(page = 1, pageSize = 10) {
	try {
		let response = await api
			.get(`vlp/test-processes?page=${page}&pageSize=${pageSize}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetTestProcess(id) {
	try {
		let response = await api
			.get(`vlp/test-processes/${id}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UpdateTestProcess(data) {  
  try {
	let response = await api.put("vlp/test-processes", { json: data });
	return response;
  } catch (error) {
	throw error;
  }
}

export async function SaveTestProcess(data) {
  try {
	let response = await api.post("vlp/test-processes", { json: data });
	return response;
  } catch (error) {
	throw error;
  }
}



export async function ProcessTestSettings(id) {
	try {
		let response = await api
			.get(`vlp/test-processes/settings/${id}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function DeleteProcess(id) {
	try {
	  let response = await api
		.delete(`vlp/test-processes/`+id)
		.json();
	  return response;
	} catch (error) {
	  throw error;
	}
  }


